var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.182 0.43934C14.7678 1.02513 14.7678 1.97487 14.182 2.56066L4.24264 12.5L14.182 22.4393C14.7678 23.0251 14.7678 23.9749 14.182 24.5607C13.5962 25.1464 12.6464 25.1464 12.0607 24.5607L0 12.5L12.0607 0.43934C12.6464 -0.146447 13.5962 -0.146447 14.182 0.43934Z",
    fill: "#2B43DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.962cad87a48e6cf1da1b3c1959f0427c.svg";
export { ForwardRef as ReactComponent };